<template lang="pug">
	.asset-image-generation(v-if="showed && creative" v-window :class="{collapsed}")
		.card-wrapper(:style="{transform: collapsed ? `translate(calc(-50vw + 50% + 58px), ${(Layout.headerHeight + Layout.subHeaderHeight) / 2}px)` : 'translate(0px, 0px)'}")
			.card(:style="{transform: `translate(${dragPosition[0]}px, ${dragPosition[1]}px), scale(${metadata.hiding ? 0.9 : 1})`}")
				.card-header
					i.fa.fa-magic
					span AI Image Generation
					button.btn.btn-sm.btn-outline-primary.collapse-left(type="button" @click="toggle()" v-b-tooltip.hover="{delay: { show: 500, hide: 100, zIndex: 5000}, title: 'Collapse left to fast switch between several images'}")
						.fa(:class="collapsed ? 'fa-angle-double-right' : 'fa-angle-double-left'")
				.card-body.collapse.show
					.form-line.description
						span.text-muted Here you can generate a new image or edit existing image using text prompt.
					.form-line.generations.separator(@wheel="scrollVariations($event)")
						//.generations-title.field-title(v-if="variations.length > 0")
							span Image variations
						//.generations-empty.field-title(v-else) There are no generations for this asset so far
						.variation-list(ref="generation-list" @scroll="updateScrollTrack()" :style="{height: collapsed ? `calc(100vh - 262px)` : '137px'}")
							.variation(v-for="variation in variations" :class="{[variation.status]: true}")
								.variation-link
									.button(@click="openVariation(variation)") {{variation.type.toUpperCase()}}
								.variation-status.status-prepare(v-if="variation.status === 'prepare'") Waiting...
								.variation-status.status-upload(v-else-if="variation.status === 'upload'") Upload...
								.variation-status.status-generate(v-else-if="variation.status === 'generate'") Generating...
								.variation-status.status-download(v-else-if="variation.status === 'download'") Download...
								.variation-status.status-error(v-else-if="variation.status === 'error'") Error
								.variation-status.status-completed(v-else-if="variation.status === 'completed'")
									.images
										.image(v-for="image in variation['images']" :class="{attached: attachments[image.imageId] === true, selected: !!image.selected}" :style="{backgroundImage: `url(${image.path})`}" @click="collapsed ? applyAsset(variation, image) : openImageInfo(variation, image)")
											.apply-variation(v-if="!collapsed && !image.selected" @click.stop="applyAsset(variation, image)") Apply variation
											.reset-variation(v-if="!collapsed && image.selected && canRevertImage(image)" @click.stop="revertImage()") Reset variation
											//.open-image(@click.stop="openImage(variation, image)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Open image'}")
												.fa.fa-external-link
											.view-image(v-if="collapsed" @click.stop="openImageInfo(variation, image)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'View image'}")
												.fa.fa-arrows-alt
											.attach-image(@click.stop="attachImage(variation, image)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Attach image as reference (with Size = Auto the output size matches the original or first attached image)'}")
												.fa.fa-paperclip
											.revert-image(v-if="collapsed && image.selected && canRevertImage(image)" @click.stop="revertImage()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Return original image'}")
												.fa.fa-close
											// Редактирование через указание маски не доделано и не факт что оно нужно. Если понадобится можно откомментировать это и доделать.
											//.edit-image(@click.stop="editImage(variation, image)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Edit image'}")
												.fa.fa-pencil
						.variation-list-scroll(v-if="variations.length > 0" :class="{'is-scrolling': isScrolling}")
							.variation-list-thrumb(v-show="isOverflow" :style="{width: scrollWidth + 'px', left: scrollLeft + 'px', height: scrollHeight + 'px', top: scrollTop + 'px'}")
					.collapsing-form
						AssetImageGenerationSettings(ref="settings" :creative="creative" :asset="asset" @change="updateSettings($event)")
					.form-actions
						.collapsing-buttons
							button.btn.btn-primary(type="button" @click="generate()" :disabled="(_.size(attachments) > 0 && !settings.removeBackground && !settings.prompt) || (_.size(attachments) === 0 && !settings.prompt)")
								i.fa.fa-plus
								span(v-if="_.size(attachments) === 0")
									span(v-if="settings.removeBackground && settings.prompt") Generate {{settings.count > 1 ? settings.count : ''}} {{settings.count > 1 ? 'images' : 'image'}} and remove background
									span(v-else-if="!settings.removeBackground && settings.prompt") Generate {{settings.count > 1 ? settings.count : ''}} {{settings.count > 1 ? 'images' : 'image'}}
									span(v-else-if="settings.removeBackground && !settings.prompt") Please type a prompt
									span(v-else-if="!settings.removeBackground && !settings.prompt") Please type a prompt
								span(v-if="_.size(attachments) === 1")
									span(v-if="settings.removeBackground && settings.prompt") Change image and remove background {{settings.count > 1 ? '(' + settings.count + ' times)' : ''}}
									span(v-else-if="!settings.removeBackground && settings.prompt") Change image {{settings.count > 1 ? '(' + settings.count + ' times)' : ''}}
									span(v-else-if="settings.removeBackground && !settings.prompt") Remove background
									span(v-else-if="!settings.removeBackground && !settings.prompt") Please type a prompt
								span(v-if="_.size(attachments) > 1")
									span(v-if="settings.removeBackground && settings.prompt") Combine {{_.size(attachments)}} images and remove background
									span(v-else-if="!settings.removeBackground && settings.prompt") Combine {{_.size(attachments)}} images
									span(v-else-if="settings.removeBackground && !settings.prompt") Remove background
									span(v-else-if="!settings.removeBackground && !settings.prompt") Please type a prompt
							button.upload-image.btn.btn-outline-secondary(type="button" @click="uploadImage($event)")
								i.fa.fa-upload
								span Upload image
							button.available-budget.btn.btn-link(v-if="Creative.getAvailableAIBudget(creative)" type="button" @click="showCreativeAISettings()")
								span Available budget: {{Creative.getAvailableAIBudgetDescription(creative)}}
						button.btn.btn-dark.right-button(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen'

	import AssetImageGenerationSettings			from './AssetImageGenerationSettings'

	export default {
		name: "AssetImageGeneration",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Creative Generations Loaded",
				"Selected Creative Generation Added",
				"Selected Creative Generation Changed: [status]",
				"Selected Creative Generation Removed",
				"Selected Creative Asset Uploads Loaded",
				"Selected Creative Asset Upload Added",
				"Selected Creative Asset Upload Removed",
				"Selected Creative Updated",
				"Creative AI Budget Changed", // для изменения доступного ИИ бюджета
				"Publishers Changed",
				"Selected Version Assets Changed"

			],
			events: {
				"Show AssetImageGeneration": function(asset, options) {

					this.asset = asset;

					// Ассета может не быть (генерация с нуля) - работаем в указанной версии, ассет создаётся при первой генерации
					if (asset) this.versionId = asset['version_id'];
					else this.versionId = options?.versionId;

					// Окно открыто из списка элементов: при первой генерации вместе с ассетом создаётся и элемент
					this.elementOptions = options?.newElementType ? {
						newElementType: options.newElementType,
						elementScreenCodename: options.elementScreenCodename,
						parentElementId: options.parentElementId
					} : null;

					this.pendingAssetCodename = null;

					this.creative = Creative.SelectedCreative;

					this.update();

					Server.sendToSocket({
						Navigation: {
							title: 'Page',
							description: 'asset-image-generation',
							data: {}
						}
					});

				},
				"AssetImageGeneration Hided": function() {

					this.collapsed = false;

				}
			}
		},
		components: {
			AssetImageGenerationSettings
		},
		data() {

			this.variations = [];

			this.creative = null;
			this.asset = null;

			// Генерация с нуля: версия, в которой создаётся ассет, данные для создания элемента
			// (если окно открыто из списка элементов) и codename ожидаемого нового ассета
			this.versionId = null;
			this.elementOptions = null;
			this.pendingAssetCodename = null;

			return {
				metadata: {hiding: false}, // нужно продублировать это из window директивы так как оно используется и в этом компоненте тоже
				attachments: {},
				settings: {},
				isOverflow: false,
				isScrolling: false,
				scrollWidth: 100,
				scrollLeft: 0,
				scrollHeight: 100,
				scrollTop: 0,
				collapsed: false
			}

		},
		methods: {
			collectData(eventName, ...params) {

				if (!this.creative) return;

				if (Creative.getCreative(this.creative.id)) this.creative = Creative.getCreative(this.creative.id);

				// Генерация с нуля: ассет создаётся на сервере при первой генерации - подхватываем его из изменившихся ассетов
				if (!this.asset && eventName === "Selected Version Assets Changed") this.adoptGeneratedAsset(params);

				this.variations = [];

				let generations = Asset.getCreativeGenerations(this.creative.id),
					uploads = Asset.getCreativeAssetUploads(this.creative.id);

				if (this.asset) {

					this.asset = Asset.getAsset(Version.getVersion(this.asset['version_id']), this.asset.codename);

					_.each(generations, generation => {

						if (generation['asset_codename'] === this.asset.codename) {

							this.variations.push({
								type: "generation",
								status: generation.status,
								images: _.map(generation["result_images"], image => {
									return {
										path: `generations/${image.fileName}`,
										fileName: image.fileName,
										imageId: `generation-${generation.id}-image-${image.vendorId}`,
										selected: (this.asset.options?.replacedFrom?.assetGenerationId === generation.id && this.asset.options?.replacedFrom?.fileName === image.fileName) || (this.asset.url.indexOf('generations/') > 0 && this.asset.url.indexOf(image.fileName) > 0)
									}
								}),
								timestamp: generation["start_time"].getTime(),
								generation
							});

						}

					});

					_.each(uploads, upload => {

						if (upload['asset_codename'] === this.asset.codename) {

							//console.log(this.asset.url, this.asset.url.indexOf('project-assets/') > 0, this.asset.url.indexOf(upload["file_name"]) > 0);

							this.variations.push({
								type: "upload",
								status: "completed",
								images: [{
									path: `project-assets/project-${upload["creative_id"]}/version-${upload["version_id"]}/${upload["file_name"]}`,
									fileName: upload["file_name"],
									imageId: `upload-${upload.id}`,
									selected: this.asset.options?.replacedFrom?.assetUploadId === upload.id || (this.asset.url.indexOf('project-assets/') > 0 && this.asset.url.indexOf(upload["file_name"]) > 0)
								}],
								timestamp: upload["date"].getTime(),
								upload
							});

						}

					});

					this.variations = _.orderBy(this.variations, "timestamp", "desc");

					//console.log(this.variations)

					let originalAssetUrl = Asset.getAssetOriginalUrl(this.asset);

					if (originalAssetUrl) {

						this.variations.push({
							type: "original", status: "completed", images: [{
								path: originalAssetUrl,
								fileName: this.asset.codename,
								imageId: `original-${this.asset.codename}`,
								selected: !Asset.AssetsByVersionByCodename[this.asset['version_id']]?.[this.asset.codename]?.url
							}]
						});

					}

				}

				this.$nextTick(() => {

					this.updateScrollTrack();

					if (this.$refs["settings"]) this.$refs["settings"].update();

				});

			},
			// Генерация с нуля: подхватывает ассет, созданный сервером при первой генерации
			// (changedAssets - пары [versionId, codename] из события "Selected Version Assets Changed")
			adoptGeneratedAsset(changedAssets) {

				if (!this.pendingAssetCodename) return;

				let version = Version.getVersion(this.versionId);

				if (!version) return;

				let assetCodename = _.find(_.map(_.filter(changedAssets, changed => changed[0] === this.versionId), '1'), codename => Asset.getAsset(version, codename)?.type === 'image'),
					asset = assetCodename ? Asset.getAsset(version, assetCodename) : null;

				if (!asset) return;

				this.asset = asset;
				this.pendingAssetCodename = null;

			},
			toggle() {

				this.collapsed = !this.collapsed;

				this.updateScrollTrack();

				this.$nextTick(() => {
					this.updateScrollTrack();
				});

				setTimeout(() => {

					this.updateScrollTrack();

				}, 210);

			},
			openVariation(variation) {

				if (variation.type === "generation") Broadcast.call("Show AssetImageGenerationInfo", [variation, variation.generation, this.asset]);
				else if (variation.type === "upload") Broadcast.call("Show AssetImageUploadInfo", [variation, variation.upload, this.asset]);
				else if (variation.type === "original") Broadcast.call("Show AssetImageOriginalInfo", [variation, this.asset]);

			},
			openImage(variation, image) {

				window.open(image.path, "_blank");

			},
			attachImage(variation, image) {

				if (this.attachments[image.imageId]) delete this.attachments[image.imageId];
				else this.attachments[image.imageId] = true;

				this.update();

				if (this.$refs["settings"]) this.$refs["settings"].setAttachmentsCount(_.size(this.attachments));

			},
			editImage(variation, image) {

				Broadcast.call("Show AssetImageGenerationEdit", [this.creative, this.asset, variation, image]);

			},
			// Сбросить вариацию можно, только если сейчас установлена не самая старая вариация
			canRevertImage(image) {

				let originalVariation = this.getOriginalVariation();

				return !!originalVariation && originalVariation.images[0].imageId !== image.imageId;

			},
			revertImage() {

				let originalVariation = this.getOriginalVariation();

				if (!originalVariation) return;

				this.applyAsset(originalVariation, originalVariation.images[0]);

			},
			// Самая старая по времени добавления готовая вариация (original, upload или generation) - на неё производится сброс.
			// Вариации отсортированы от новых к старым, original всегда в конце списка
			getOriginalVariation() {

				return _.findLast(this.variations, variation => variation.status === "completed" && _.size(variation.images) > 0);

			},
			applyAsset(variation, image) {

				if (variation.type === "generation") {

					Server.sendToServer({
						ApplyAssetGeneration: {
							assetGenerationId: variation.generation.id,
							fileName: image.fileName
						}
					});

				} else if (variation.type === "upload") {

					Server.sendToServer({
						ApplyAssetUpload: {
							assetUploadId: variation.upload.id
						}
					});

				} else if (variation.type === "original") {

					Server.sendToServer({
						ResetAssetUrl: {
							versionId: this.asset['version_id'],
							assetCodename: this.asset.codename
						}
					});

				}

			},
			openImageInfo(variation, image) {

				Broadcast.call("Show AssetImageInfo", [this.creative, this.asset, variation, image]);

			},
			scrollVariations(e) {

				if (e.deltaY !== 0) {

					e.preventDefault();

					if (this.collapsed) {

						this.$refs["generation-list"].scrollTop += e.deltaY * 3;

					} else {

						this.$refs["generation-list"].scrollLeft += e.deltaY * 3;

					}

					this.isScrolling = true;

					clearTimeout(this.scrollingTimeout);
					this.scrollingTimeout = setTimeout(() => {

						this.isScrolling = false;

					}, 600);

				}

			},
			updateScrollTrack() {

				if (this.collapsed) {

					this.isOverflow = this.$refs["generation-list"].scrollHeight > this.$refs["generation-list"].clientHeight;

					if (this.isOverflow) {

						this.scrollWidth = 8;
						this.scrollLeft = 0;

						this.scrollHeight = (this.$refs["generation-list"].clientHeight / this.$refs["generation-list"].scrollHeight) * this.$refs["generation-list"].clientHeight;
						this.scrollTop = (this.$refs["generation-list"].scrollTop / (this.$refs["generation-list"].scrollHeight - this.$refs["generation-list"].clientHeight)) * (this.$refs["generation-list"].clientHeight - this.scrollHeight);

					}

				} else {

					this.isOverflow = this.$refs["generation-list"].scrollWidth > this.$refs["generation-list"].clientWidth;

					if (this.isOverflow) {

						this.scrollHeight = 8;
						this.scrollTop = 0;

						this.scrollWidth = (this.$refs["generation-list"].clientWidth / this.$refs["generation-list"].scrollWidth) * this.$refs["generation-list"].clientWidth;
						this.scrollLeft = (this.$refs["generation-list"].scrollLeft / (this.$refs["generation-list"].scrollWidth - this.$refs["generation-list"].clientWidth)) * (this.$refs["generation-list"].clientWidth - this.scrollWidth);

					}

				}

			},
			updateSettings(settings) {

				this.settings = settings;

			},
			generate() {

				let settings = this.$refs["settings"].getSettings();

				// Генерация с нуля: ассета ещё нет - сервер создаст его (и элемент, если окно открыто из списка элементов)
				// при первой генерации. Запоминаем codename, чтобы подхватить созданный ассет
				if (!this.asset) this.pendingAssetCodename = this.getGeneratedAssetCodename(settings.prompt);

				Server.sendToServer({
					GenerateImage: {
						versionId: this.versionId,
						assetCodename: this.asset ? this.asset['codename'] : '',
						aiVendorCodename: settings.vendorCodename,
						aiModelCodename: settings.modelCodename,
						aiStyleCodenames: settings.styleCodenames,
						aiSizeCodename: settings.sizeCodename,
						removeBackground: settings.removeBackground,
						prompt: settings.prompt,
						attachments: Object.keys(this.attachments),
						count: settings.count,
						newAssetCodename: this.pendingAssetCodename ? this.pendingAssetCodename : '',
						newElementType: this.elementOptions ? this.elementOptions.newElementType : '',
						elementScreenCodename: this.elementOptions ? this.elementOptions.elementScreenCodename : '',
						elementId: this.elementOptions ? this.elementOptions.parentElementId : 0
					}
				});

				this.attachments = {};

				this.update();

				if (this.$refs["settings"]) this.$refs["settings"].setAttachmentsCount(_.size(this.attachments));

			},
			// codename нового ассета при генерации с нуля - по промпту (как у ИИ агента); уникальность обеспечивает сервер
			getGeneratedAssetCodename(prompt) {

				return _.trim(_.kebabCase(prompt).substring(0, 60), '-') || 'ai-image';

			},
			uploadImage() {

				Asset.requestFile('image/png,image/jpeg,image/gif', file => {

					Asset.uploadAsset(this.asset, file);

				});

			},
			showCreativeAISettings() {

				Broadcast.call("Show CreativeSettingsAI");

			}
		}
	}
</script>

<style lang="sass">

	.asset-image-generation
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card-wrapper
			display: flex
			margin: auto
			transition: 0.3s

		.card-header

			.collapse-left
				margin-left: auto

				.fa
					font-size: 18px
					margin-top: 4px
					margin-bottom: 3px
					width: 15px

		.description
			height: 25px
			align-items: center
			overflow: hidden
			transition: 0.3s
			margin-bottom: 15px

			.collapse-left

				.fa
					font-size: 18px
					margin-top: 4px
					margin-bottom: 3px
					width: 15px

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 940px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			button
				white-space: nowrap

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				color: #fff

			.btn-link
				color: #fff

			.btn-link:hover
				color: #fff

		.form-group
			display: flex
			flex-direction: column
			margin: 0

			&:first-child
				margin-left: 0

		.form-line
			display: flex
			flex-direction: row

		.field-title
			margin-bottom: 5px
			cursor: default
			color: var(--gray)

		.generations
			display: flex
			flex-direction: column
			position: relative
			padding-bottom: 6px

			.generations-title
				height: 21px // Важно для анимации сжатия
				margin-bottom: 10px
				display: flex
				flex-direction: row
				justify-content: left
				align-items: center
				transition: 0.3s
				overflow: hidden

			.variation-list
				display: flex
				flex-direction: row
				overflow-x: auto
				scrollbar-width: none
				-ms-overflow-style: none
				scroll-behavior: smooth
				transition: 0.3s

				&::-webkit-scrollbar
					display: none

				.variation
					border: 1px solid
					margin-right: 10px
					padding: 5px

					.variation-status
						display: flex
						flex-direction: column
						justify-content: center
						align-items: center
						min-width: 100px
						height: 100px

					.status-prepare
						color: var(--gray)
						min-width: 100px

					.status-generate
						color: var(--yellow)
						min-width: 100px

					.status-download
						color: var(--green)
						min-width: 100px

					.status-error
						color: var(--danger)
						min-width: 100px

					.status-completed

					.variation-link
						display: flex
						flex-direction: row
						align-items: center
						justify-content: center
						height: 20px
						margin-bottom: 5px

						.button
							cursor: pointer
							//width: 70px
							//height: 22px
							text-align: center
							border: 1px dashed transparent
							border-radius: 3px
							opacity: 0.3
							font-size: 10px
							letter-spacing: 1px
							padding: 3px 5px
							display: flex
							justify-content: center
							align-items: center

							&:hover
								border-color: var(--primary)
								color: var(--primary)
								opacity: 1

					.images
						display: flex
						flex-direction: row

				.variation.prepare
					border-color: var(--gray)

				.variation.generate
					border-color: var(--yellow)

				.variation.download
					border-color: var(--green)

				.variation.error
					border-color: var(--danger)

				.variation.completed, .original
					border: 1px solid var(--gray-dark)

				.original-title
					display: flex
					flex-direction: row
					align-items: center
					justify-content: center
					height: 20px
					margin-bottom: 5px

					.button
						cursor: default
						//width: 70px
						//height: 22px
						text-align: center
						border: 1px dashed transparent
						border-radius: 3px
						opacity: 0.3
						font-size: 10px
						letter-spacing: 1px
						padding: 3px 5px
						display: flex
						justify-content: center
						align-items: center

				.image
					position: relative
					width: 100px
					height: 100px
					background-position: center
					background-size: contain
					background-repeat: no-repeat
					background-color: rgba(0,0,0,0.3)
					border-radius: 5px
					overflow: hidden
					border: 1px solid var(--gray-dark)
					box-shadow: 0px 0px 5px var(--gray-dark)
					cursor: pointer
					margin-left: 5px

					.apply-variation, .reset-variation
						//display: none
						position: absolute
						left: 0
						top: 0
						width: 100%
						height: 30px
						background-color: var(--primary)
						text-align: center
						justify-content: center
						align-items: center
						padding-bottom: 4px
						opacity: 0
						user-select: none

					.reset-variation
						background-color: var(--danger)

					.download-image, .open-image, .view-image, .attach-image, .edit-image, .revert-image
						display: none
						justify-content: center
						align-items: center
						position: absolute
						bottom: 0
						left: 0
						width: 30px
						height: 30px
						cursor: pointer
						text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.7)
						//background: radial-gradient(circle, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 70%)

						&:hover
							color: var(--primary)

					.open-image
						left: 35px

					.view-image
						left: 3px
						bottom: 2px

					.attach-image
						left: auto
						right: 0
						font-size: 16px
						bottom: 1px

					.edit-image
						left: auto
						right: 0
						top: 1px

					.revert-image
						top: 0
						left: auto
						right: 0
						width: 35px
						height: 35px

						&:hover
							color: var(--danger)

				.image:hover
					border-color: var(--primary)

					.apply-variation, .reset-variation
						display: flex
						opacity: 0.5

						&:hover
							opacity: 0.9

					.download-image, .open-image, .view-image, .attach-image, .edit-image
						display: flex

				.image:first-child
					margin-left: 0

				.image.selected
					border-color: var(--green)

					.revert-image
						display: flex

				.image.attached
					border-color: var(--orange)

					.attach-image
						display: flex
						color: var(--orange)

			.variation-list-scroll
				display: flex
				position: relative
				width: 100%
				height: 8px
				background-color: rgba(0,0,0,0.05)
				margin-top: 6px
				border-radius: 5px
				opacity: 0
				transition: opacity 0.2s

				.variation-list-thrumb
					position: absolute
					left: 0
					height: 8px
					background-color: rgba(0,0,0,0.1)
					border-radius: 5px

			.variation-list-scroll.is-scrolling
				opacity: 1

		.collapsing-form
			height: 255px
			transition: 0.3s

		.form-actions
			display: flex
			flex-direction: row
			align-items: center
			margin-top: 20px
			transition: 0.3s

			.collapsing-buttons
				display: flex
				flex-direction: row
				align-items: center
				width: 800px
				height: 35px
				transition: 0.3s
				overflow: hidden

			.available-budget
				margin-left: 20px
				white-space: nowrap

			.right-button
				margin-left: auto

			.upload-image
				margin-left: 20px

	.asset-image-generation.collapsed
		background-color: transparent
		pointer-events: none !important
		user-select: none

		.card
			width: 251px
			pointer-events: all
			box-shadow: none
			transform: none !important

		.generations
			flex-direction: row

			.generations-title
				width: 0
				height: 0
				margin-bottom: 0

			.variation-list
				flex-direction: column
				overflow-y: auto
				overflow-x: hidden

				.variation
					margin-right: 0
					margin-bottom: 10px

					.variation-status
						height: auto

				.images
					flex-direction: column
					align-items: center

				.image
					width: 200px
					height: 200px
					border-width: 2px
					margin-left: 0
					margin-top: 10px

					.download-image, .open-image, .view-image, .attach-image, .edit-image
						opacity: 0.2
						font-size: 20px

						&:hover
							opacity: 1

					.revert-image
						opacity: 0.2
						font-size: 23px

						&:hover
							opacity: 1

					.attach-image
						display: none

				.image:first-child
					margin-top: 0

			.variation-list-scroll
				position: absolute
				width: 8px
				height: 100%
				left: -20px
				margin-top: 0
				margin-left: 6px
				visibility: hidden // выглядит этот скролл в свернутом состояниине очень - много вертикальных полос среди которых он теряется

		.collapsing-form
			height: 0
			overflow: hidden

		.description
			height: 0
			margin-bottom: 0
			padding-bottom: 0
			border: 0
			overflow: hidden

		.form-actions
			margin-top: 10px
			justify-content: center

			.collapsing-buttons
				width: 0

			.right-button
				margin-left: inherit

</style>

